import {Component} from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams, Platform} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {SocialSharing} from "@ionic-native/social-sharing";

@Component({
    selector: 'page-whtsp',
    templateUrl: 'whtsp.html',
})
export class WhtspPage {

    Standard = 'All';
    StandardData = {};

    WebEnquiryData = [];
    WebEnquiryData1: any;
    DataSearch: any;
    datanotfound: any;

    statusbar = 'All';
    StatusData = {};

    //count
    CountAll: any;
    CountDataAdded: any;
    CountApmtBooked: any;
    CountEnqAttended: any;
    CountFeedbackSubmitted: any;
    CountAdmissionDone: any;
    StdAllCount: any;
    StdPGCount: any;
    StdNurCount: any;
    StdJrCount: any;
    StdSrCount: any;
    Std1Count: any;
    Std2Count: any;
    Std3Count: any;
    Std4Count: any;
    Std5Count: any;
    Std6Count: any;
    Std7Count: any;

    IsSearch = 0;
    page = 1;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public platform: Platform,
                private socialSharing: SocialSharing,
                public service: ServiceProvider,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController) {
        this.platform.ready().then(() => {
            this.StandardData = {
                "All": 0,
                "P": 1,
                "N": 2,
                "J": 3,
                "S": 4,
                "1": 5,
                "2": 6,
                "3": 7,
                "4": 8,
                "5": 9,
                "6": 10,
                "7": 11,
            }
            this.StatusData = {
                "All": 0,
                "DataAdded": 1,
                "AppointmentBooked": 2,
                "EnquiryAttended": 3,
                "FeedbackSubmitted": 4,
                "AdmissionDone": 5,
                "Testing": 6
            }
            this.active_tab(this.statusbar);
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad DashboradPage');
    }

    active_tab(tab) {
        console.log(tab);
        this.Standard = tab;
        this.active_statustab(this.statusbar);
        this.loadStatusCountvalues(this.StandardData[this.Standard]);

    }

    active_statustab(tab) {
        this.statusbar = tab;
        this.IsSearch = 0;
        this.DataSearch = null;
        this.WebEnquiryData = [];
        this.page = 1;
        this.loadvalues(this.StandardData[this.Standard], this.StatusData[this.statusbar], this.page);
        this.loadCountvalues();
    }

    loadvalues(Standard, Status, Page) {
        // let loading = this.loadingCtrl.create({
        //     content: 'Loading'
        // });
        // loading.present();
        //
        // setTimeout(() => {
        //     loading.dismiss();
        //     loading = undefined;
        // }, 5000);

        this.datanotfound = null;
          this.service.httpcall('web_service/get_web_enquiry_by_standard?Standard=' + Standard + '&Status=' + Status + '&page=' + Page).subscribe(data => {
            // if (loading)
            //     loading.dismiss();
            // loading = undefined;
            console.log("Data", data);
            if (data['response'] == "success") {
                for (let i = 0; i < data['Data'].length; i++) {
                    this.WebEnquiryData.push(data['Data'][i]);
                }
                this.datanotfound = null;
            } else {
                this.datanotfound = "Data Not Found";
            }
        });
    }

    searchData() {
        this.IsSearch = 1;
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();
        setTimeout(() => {
            loading.dismiss();
        }, 5000);

        console.log("Search:", this.DataSearch);
        this.WebEnquiryData = [];
        this.datanotfound = null;
        this.service.httpcall('web_service/get_web_enquiry_by_standard_search?Standard=' + this.StandardData[this.Standard] + '&Status=' + this.StatusData[this.statusbar] + '&Search=' + this.DataSearch).subscribe(data => {
            if (loading)
                loading.dismiss();
            loading = undefined;
            console.log(data);
            if (data['response'] == "success") {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                this.datanotfound = null;
                this.WebEnquiryData = data['Data'];
            } else {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                this.datanotfound = data['error_description'];
            }

        })
    }

    loadCountvalues() {

        this.service.httpcall('web_service/get_standardCount_web_enquiry?').subscribe(data => {
            console.log(data);
            this.StdAllCount = data['StdAllCount'];
            this.StdPGCount = data['StdPGCount'];
            this.StdNurCount = data['StdNurCount'];
            this.StdJrCount = data['StdJrCount'];
            this.StdSrCount = data['StdSrCount'];
            this.Std1Count = data['Std1Count'];
            this.Std2Count = data['Std2Count'];
            this.Std3Count = data['Std3Count'];
            this.Std4Count = data['Std4Count'];
            this.Std5Count = data['Std5Count'];
            this.Std6Count = data['Std6Count'];
            this.Std7Count = data['Std7Count'];
        });
    }

    loadStatusCountvalues(standard) {

        this.service.httpcall('web_service/get_StatusCount_web_enquiry_by_standard?standard=' + standard).subscribe(data => {
            console.log(data);
            this.CountAll = data['CountAll'];
            this.CountDataAdded = data['CountDataAdded'];
            this.CountApmtBooked = data['CountApmtBooked'];
            this.CountEnqAttended = data['CountEnqAttended'];
            this.CountFeedbackSubmitted = data['CountFeedbackSubmitted'];
            this.CountAdmissionDone = data['CountAdmissionDone'];
        });
    }

    send_msg(enquirydata,BtnMsg) {

        console.log("Message -> ",BtnMsg);
        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, BtnMsg, null, null);
                    }
                }
            ]
        });

        if(enquirydata.Phone1!=null && (enquirydata.Phone2=="" || enquirydata.Phone2==null)  ){
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + enquirydata.Phone1, BtnMsg, null, null);
        }else{
            if (enquirydata.Phone1) {
                myAlert.addInput({
                    type: 'radio',
                    label: enquirydata.Phone1,
                    value: enquirydata.Phone1,
                    checked: true
                })
            }

            if (enquirydata.Phone2) {
                myAlert.addInput({
                    type: 'radio',
                    label: enquirydata.Phone2,
                    value: enquirydata.Phone2
                })
            }

            myAlert.present();
        }




    }

    send_msg1(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg, null, null);
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone1,
            value: enquirydata.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone2,
            value: enquirydata.Phone2
        })
        myAlert.present();


    }

    send_msg2(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg2, null, null);
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone1,
            value: enquirydata.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone2,
            value: enquirydata.Phone2
        })
        myAlert.present();


    }

    send_msg3(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg3, null, null);
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone1,
            value: enquirydata.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone2,
            value: enquirydata.Phone2
        })
        myAlert.present();


    }

    send_msg4(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, enquirydata.Msg4, null, null);
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone1,
            value: enquirydata.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone2,
            value: enquirydata.Phone2
        })
        myAlert.present();


    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);
        this.WebEnquiryData = [];
        this.page = 1;
        this.IsSearch = 0;
        this.DataSearch = null;
        this.loadvalues(this.StandardData[this.Standard], this.StatusData[this.statusbar], this.page);
        this.loadCountvalues();
        this.loadStatusCountvalues(this.StandardData[this.Standard]);
        setTimeout(() => {
            console.log('Async operation has ended');
            refresher.complete();
        }, 2000);
    }

    doInfinite(infiniteScroll) {
        if (this.IsSearch == 0) {
            console.log('Begin async operation');

            setTimeout(() => {
                // for (let i = 0; i < 30; i++) {
                //   this.items.push( this.items.length );
                // }
                this.page = this.page + 1;
                console.log("page number ", this.page);
                this.loadvalues(this.StandardData[this.Standard], this.StatusData[this.statusbar], this.page);

                console.log('Async operation has ended');
                infiniteScroll.complete();
            }, 500);
        } else {
            console.log('Begin async operation');

            setTimeout(() => {
                // for (let i = 0; i < 30; i++) {
                console.log('Async operation has ended');
                infiniteScroll.complete();
            }, 500);
        }

    }
}



// WEBPACK FOOTER //
// ./src/pages/whtsp/whtsp.ts